import { ParagrafoDTO } from '@framework/api-client';
import { CoverParagraphViewItem } from '@framework/common-web';
import React from 'react';
import styled from 'styled-components';

const CoverParagraphsContainer = styled.div`
  padding-top: 24px;
`;

function generateKey(paragraph: ParagrafoDTO, index: number) {
  return `${paragraph.titolo?.split(' ')[0] ?? 'p'}-${index}`;
}
export interface ICoverParagraphsProps {
  paragraphs: ParagrafoDTO[] | null | undefined;
}

/**
 * Componente per la visualizzazione dei paragrafi di copertina
 */
export function CoverParagraphs(props: ICoverParagraphsProps) {
  const { paragraphs } = props;
  if (!paragraphs) return null;

  return (
    <CoverParagraphsContainer>
      {paragraphs.map((paragraph, i) => (
        <CoverParagraphViewItem
          title={paragraph.titolo}
          text={paragraph.corpo}
          key={generateKey(paragraph, i)}
        />
      ))}
    </CoverParagraphsContainer>
  );
}
